import { render, staticRenderFns } from "./editRuledetail.vue?vue&type=template&id=5ee24a55&scoped=true&"
import script from "./editRuledetail.vue?vue&type=script&lang=js&"
export * from "./editRuledetail.vue?vue&type=script&lang=js&"
import style0 from "./editRuledetail.vue?vue&type=style&index=0&id=5ee24a55&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ee24a55",
  null
  
)

export default component.exports